import React, { useEffect, useState } from "react";

export default function ExportMenu({ onExport }) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const close = () => setOpen(false);
    if (open) document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, [open]);

  const btn = {
    padding: "8px 12px",
    borderRadius: 8,
    border: "1px solid #1f2834",
    background: "#151b24",
    color: "white",
    cursor: "pointer",
  };
  const menuWrap = { position: "relative", display: "inline-block" };
  const menu = {
    position: "absolute",
    top: "100%",
    right: 0,
    background: "#0f141c",
    border: "1px solid #1f2834",
    borderRadius: 8,
    padding: 6,
    minWidth: 140,
    zIndex: 20,
    boxShadow: "0 8px 20px rgba(0,0,0,0.4)",
  };
  const item = {
    padding: "8px 10px",
    color: "#e6edf3",
    cursor: "pointer",
    borderRadius: 6,
  };
  const itemHover = { background: "#172131" };

  return (
    <div style={menuWrap} onClick={(e) => e.stopPropagation()}>
      <button style={btn} onClick={() => setOpen((o) => !o)}>Export ▾</button>
      {open && (
        <div style={menu}>
          {["CSV", "Excel", "PDF", "Print"].map((label) => (
            <div
              key={label}
              onClick={() => { onExport(label.toLowerCase()); setOpen(false); }}
              onMouseEnter={(e) => (e.currentTarget.style.background = itemHover.background)}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
              style={item}
            >
              {label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
